<div class="analyticsPage new">
  <div class="wrpr">
    <div class="breadCrumbCont">
      <a class="breadCrumbLink" routerLink="/analytics" [ngClass]="{'active': router.url === '/analytics'}">
        Analytics Home
      </a>
      <p>/</p>
      <a class="breadCrumbLink" routerLink="/all-analytics" [ngClass]="{'active': router.url === '/all-analytics'}">
        All Analytics
      </a>
      <p *ngIf="router.url !== '/analytics' && router.url !== '/all-analytics'">/</p>
      <a class="breadCrumbLink" style="text-decoration: none;    color: #525252;"
        *ngIf="router.url !== '/analytics' && router.url !== '/all-analytics'">
        {{reportName}}
      </a>
    </div>
    <div class="contentCard">
      <div id="toolbar" *ngIf="embedReports.length > 0">
        <button type="button" mat-button (click)="toggleEdit()" [ngClass]="{activeBtn: activeBtn=='Toggle Edit Mode'}"
          *ngIf="isEditAllowed">
          Toggle Edit Mode</button>
        <button type="button" mat-button (click)="fullSrceen()" [ngClass]="{activeBtn: activeBtn=='Full Screen'}">
          Full Screen</button>
        <button type="button" mat-button (click)="print()" [ngClass]="{activeBtn: activeBtn=='Print'}">Print</button>
      </div>
      <powerbi-report cssClassName="powerbi-container" [phasedEmbedding]="false" [embedConfig]="reportConfig"
        [eventHandlers]="eventHandlersMap" id="reportContainer" *ngIf="!flagError"></powerbi-report>


    </div>
  </div>
</div>

<app-error-toast
  [message]="errorMessage"
  *ngIf="errorMessage && flagError"
></app-error-toast>